import * as angular from "angular";
import {IController, ILogService} from "angular";
import * as _ from "lodash";
import {ItemSetting} from "../../../price-plan/models/itemSetting.model";
import {LabelsService} from "../../../labels/services/labels-service.service";
import {PackageConfigurationService,} from "../../../site-preferences/services/package-configuration-service.service";
import {
  DefaultPackageConfigurationFieldsType
} from "../../../site-preferences/types/default-package-configuration-fields.type";

export class packageListUpdateComponent implements IController {

  packages: any;
  packageSizes: any;
  defaultItemSize: any;
  isRequired: boolean;
  expendAll: boolean;
  isTypeEnabled: boolean;
  onPackageChange: Function;

  public readonly defaultPackageConfigurationFieldsTypesMap: typeof DefaultPackageConfigurationFieldsType = DefaultPackageConfigurationFieldsType;

  public packagesOptionTypes: string[];
  public packageItemOptions: ItemSetting[];
  private labelOptions: any;
  private weightConfig: any;
  private dimensionsConfig: any;
  private sitePackageItems: ItemSetting[];

  private packageConfigurationByType: any;
  public packageConfigurationCustomFieldsByType: any;
  public packageCustomFieldsMap: any;


  /* @ngInject */
  constructor(private orderConstants,
              private labelsService: LabelsService,
              private splitService,
              private $log: ILogService,
              private packageConfigurationService: PackageConfigurationService) {
    this.weightConfig = this.splitService.getWeightUnit();
    this.dimensionsConfig = this.splitService.getVolumeUnit();
    this.sitePackageItems = this.splitService.getSitePackageItems();

  }

  $onInit() {
    this.packageConfigurationByType = this.packageConfigurationService.getPackageConfigurationsBySize();
    this.packageConfigurationCustomFieldsByType = this.packageConfigurationService.getPackageConfigurationsCustomFieldsBySize();

    this.packageItemOptions = [];
    this.labelOptions = [];

    if (this.packageSizes && this.packageSizes.length) {
      const itemSizes = _.map(this.packageSizes, 'itemSize');
      this.packageItemOptions = _.filter(this.sitePackageItems, (sitePackageItem) => {
        return _.includes(itemSizes, sitePackageItem.id);
      })
    } else {
      this.packageItemOptions = angular.copy(this.sitePackageItems);
    }

    this.packagesOptionTypes = [];
    this.packagesOptionTypes = _.map(this.packageItemOptions, (s: any) => {
      return s.id;
    })

    if (!this.labelOptions.length) {
      this.labelsService.getAll()
        .then((labels) => {
          this.labelOptions = labels;
        })
        .catch((error) => {
          this.$log.error('Failed to get Label options', error);
        })
    }

    this.setPackageCustomFieldsMap(this.packages);
  };

  $onChanges(changes) {
    if (changes.packages && !changes.packages.isFirstChange()) {
      this.$onInit();
    }
    if (changes.expendAll && !changes.expendAll.isFirstChange()) {
      this.packages.forEach((p) => {
        p.expended = this.expendAll;
      })
    }
    if (changes.packageSizes && !changes.packageSizes.isFirstChange()) {
      this.$onInit();
    }
  };

  // addPackages(defaultItemSizeName, numOfPackages: number) {
  //   if (numOfPackages < 1) return;
  //
  //   const defaultItem = _.find(this.packageSizes, (p) => {
  //     return p.itemSize === defaultItemSizeName
  //   });
  //   if (defaultItem) {
  //     this.defaultItemSize = angular.copy(_.get(defaultItem, 'itemSize'));
  //   }
  //
  //   const packagesToAdd = Array(numOfPackages)
  //     .fill(undefined)
  //     .map((_, i) => this._getNewPackage(defaultItem));
  //
  //   this.packages.push(...packagesToAdd);
  // }

  onRemove(index) {
    this.packages.splice(index, 1);
  }

  onDuplicate(index) {
    const packageToDuplicate = angular.copy(this.packages[index]);
    packageToDuplicate.id = undefined;
    // Barcodes must be unique - required ones are generated on save
    packageToDuplicate.barcode = null;

    this.packages.splice(index + 1, 0, packageToDuplicate);
    this.setPackageCustomFieldsMap(this.packages);
  }

  onCountChange(index, count) {
    this.packages[index].count = count;
  }

  onPackageTypeChange(item, selectedType, index) {
    if (item.type === selectedType) {
      return;
    }

    const packageObject = _.find(this.packageSizes, (ps) => {
      return ps.itemSize === selectedType;
    });

    let updatedItem: any = {
      id: item.id,
      count: item.count,
      type: selectedType,
      expended: item.expended
    }

    if (packageObject) {
      updatedItem.labels = packageObject.labels;
      updatedItem.dimensions = packageObject.dimensions || {};
      updatedItem.weight = packageObject.weight;
    }

    if(this.packageConfigurationByType[selectedType][this.defaultPackageConfigurationFieldsTypesMap.Barcode] && !!item.barcode){
      updatedItem.barcode = item.barcode;
    }

    if(this.packageConfigurationByType[selectedType][this.defaultPackageConfigurationFieldsTypesMap.Value] && !!item.value){
      updatedItem.value = item.value;
    }


    this.onPackageChange({package: updatedItem, index: index});
  }

  onLabelChanges(labels, packageRef) {
    packageRef.labels = labels;
  }

  onVolumeChange(packageItem, cubeValue) {
    if (!cubeValue) {
      packageItem.dimensions = {};
    } else {
      packageItem.dimensions.height = 1;
      packageItem.dimensions.length = 1;
      packageItem.dimensions.width = cubeValue;
    }
  }

  customFieldChange(updatedConfiguredField, item) {
    if (typeof item.configuredFields === "undefined" && updatedConfiguredField.value !== undefined) {
      item.configuredFields = [updatedConfiguredField];
    } else {
      const index = item.configuredFields?.findIndex(cf => cf.fieldName === updatedConfiguredField.fieldName);
      if (index !== -1) {
        item.configuredFields[index] = updatedConfiguredField;
      } else {
        item.configuredFields.push(updatedConfiguredField);
      }
    }

    this.setPackageCustomFieldsMap(this.packages);
  }

  private setPackageCustomFieldsMap(packages) {
    this.packageCustomFieldsMap = {}
    if (!packages || !packages.length) {
      return;
    }

    packages.forEach((p,i) => {
      if (p.configuredFields && p.configuredFields.length) {
        this.packageCustomFieldsMap[i] = {};

        p.configuredFields.forEach(cf => {
          this.packageCustomFieldsMap[i][cf.packageFieldId] = cf.value
        })

      }
    })
  }

  // private _getNewPackage(defaultItem){
  //   const newPackage = {
  //     count: 1,
  //     barcode: null,
  //     value: _.get(defaultItem, 'value'),
  //     size: _.get(defaultItem, 'itemSize'),
  //     labels: _.get(defaultItem, 'labels', []),
  //     dimensions: angular.copy(_.get(defaultItem, 'dimensions', {})),
  //     weight: _.get(defaultItem, 'weight'),
  //   };
  //   if (this.isTypeEnabled) {
  //     _.set(newPackage, 'type', _.get(defaultItem, 'itemSize'))
  //   }
  //
  //   return newPackage
  // }

}

angular
  .module('bringoz.admin.orders')
  .component('packageListUpdate', {
    require: {
      form: '^form'
    },
    bindings: {
      packages: '<',
      packageSizes: '<?',
      defaultItemSize: '<?',
      isTypeEnabled: '<?',
      isRequired: '<',
      expendAll: '<',
      onPackageChange: '&'
    },
    template: require('./package-list-update.html').default,
    controller: packageListUpdateComponent
  });
